import { API_BASE_URL } from '../../../config/api';

async function postJson(path, body, errorLabel, signal) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    signal,
  });

  const contentType = response.headers.get('content-type') || '';

  if (!response.ok) {
    const detail = await response.text().catch(() => '');
    throw new Error(
      `${errorLabel} failed (${response.status})${detail ? `: ${detail}` : ''}`,
    );
  }

  if (contentType.includes('application/json')) {
    return response.json();
  }

  const text = await response.text();
  return { message: text };
}

export function sendChatMessage(sessionId, messages) {
  return postJson('/chat', { sessionId, messages }, 'chat');
}

export function generateWireframe(sessionId, messages, options = {}) {
  return postJson(
    '/wireframe',
    { sessionId, messages },
    'wireframe',
    options.signal,
  );
}

export function captureLead(leadData) {
  return postJson('/lead', leadData, 'lead');
}
